import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsDashboardsProjectsReportsExportProcessMutation() {
  return useMutation({
    mutationFn: async ({ exportProcessParams }) => {
      const response = await axios.post(
        '/projects_dashboards/projects_reports/export_processes',
        { export_process: exportProcessParams },
      );

      return response.data;
    },
  });
}
